import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    rating: 5,
    description: "",
    name: "",
    imageURL: null,
    imageDetails: undefined,
    error: undefined,
    selectedTags: [],
    fileName: null,
    submittedID: null
};

export const setCurrentRating = (state = INITIAL_STATE, { rating }) => {
    return { ...state, rating };
};

export const setDescription = (state = INITIAL_STATE, { description }) => {
    return { ...state, description };
};

export const setName = (state = INITIAL_STATE, { name }) => {
    return { ...state, name };
};

export const setCroppedImageDetails = (state = INITIAL_STATE, { imageDetails }) => {
    return { ...state, imageDetails };
};

export const setImageURL = (state = INITIAL_STATE, { imageURL }) => {
    return { ...state, imageURL };
};

export const setError = (state = INITIAL_STATE, { error }) => {
    return { ...state, error };
};

export const updateSelectedTags = (state = INITIAL_STATE, { selectedTags }) => {
    return { ...state, selectedTags };
};

export const updateImageFileName = (state = INITIAL_STATE, { fileName }) => {
    return { ...state, fileName };
};

export const updateCustomerReviewID = (state = INITIAL_STATE, { submittedID }) => {
    return { ...state, submittedID };
};

export const HANDLERS = {
    [Types.SET_CURRENT_RATING]: setCurrentRating,
    [Types.SET_DESCRIPTION]: setDescription,
    [Types.SET_NAME]: setName,
    [Types.SET_CROPPED_IMAGE_DETAILS]: setCroppedImageDetails,
    [Types.SET_IMAGE_URL]: setImageURL,
    [Types.SET_ERROR]: setError,
    [Types.UPDATE_SELECTED_TAGS]: updateSelectedTags,
    [Types.UPDATE_IMAGE_FILE_NAME]: updateImageFileName,
    [Types.UPDATE_CUSTOMER_REVIEW_ID]: updateCustomerReviewID

};

export default createReducer(INITIAL_STATE, HANDLERS);
